import React from 'react';
import { Button, Col, Divider, Popover, Row, Typography } from 'components';
import { DeleteIcon, EditIcon } from 'components/common/icons';
import { Manager } from 'components/common/management/Manager';
import { ManagementRoleMapping } from 'models/Manager';
import { SalesManagerType } from '..';
import styles from '../styles.module.scss';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

interface ISalesManager {
  data: SalesManagerType;
  onDelete: () => void;
  onEdit: () => void;
}

export const SalesManagerCard = React.memo((props: ISalesManager) => {
  const { data, onDelete, onEdit } = props;
  const first4Countries = data?.countryResponseList?.slice(0, 4) || [];
  const restCountries = data?.countryResponseList?.slice(4) || [];
  return (
    <>
      <Row className={styles.sales_manager_card}>
        <Col span={24} className={styles.actions}>
          <HasAccess role={PERMISSIONS.brands.sales_management.delete}>
            <Button title={'Delete'} type={'link'} icon={<DeleteIcon />} onClick={onDelete} />
          </HasAccess>
          <HasAccess role={PERMISSIONS.brands.sales_management.write}>
            <Button title={'Edit'} type={'link'} icon={<EditIcon />} onClick={onEdit} />
          </HasAccess>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 4]}>
            <Col span={24}>
              <Manager role={ManagementRoleMapping.salesManager} data={data?.salesManager} />
            </Col>
            <Col span={24}>
              <Manager role={ManagementRoleMapping.salesManagerAssistant} data={data?.salesManagerAssistant} />
            </Col>
            {first4Countries?.length ? (
              <Col span={24}>
                <Row justify={'space-between'}>
                  <Col>
                    <Typography.Text className={'font-size-16'} type={'secondary'}>
                      Countries
                    </Typography.Text>
                  </Col>
                  <Col className={styles.country_list}>
                    <Typography.Text type={'secondary'} className={'font-size-16'}>
                      {first4Countries.map((i) => i.name).join(', ')}
                    </Typography.Text>
                    {restCountries?.length ? (
                      <Popover
                        overlayStyle={{ maxWidth: 350 }}
                        placement="topLeft"
                        content={restCountries.map((i) => i.name).join(', ')}
                      >
                        <Typography.Text
                          type={'secondary'}
                          className={'font-size-16'}
                        >{` +${restCountries.length}`}</Typography.Text>
                      </Popover>
                    ) : (
                      ''
                    )}
                  </Col>
                </Row>
              </Col>
            ) : (
              ''
            )}
          </Row>
        </Col>
      </Row>
      <Divider className={styles.divider} />
    </>
  );
});
